import api from './api';

export const receiptService = {
  // Fetch receipt by unique Receipt Number
  getReceiptByNo: async (receiptNo) => {
    const response = await api.get('/receipts/by-no', { params: { receiptNo } });
    return response.data;
  },

  // Fetch receipt by Lab / Work Order Number
  getReceiptByLabNo: async (labno) => {
    const response = await api.get(`/receipts/workorder/${encodeURIComponent(labno)}`);
    return response.data;
  },

  // Get printable HTML URL
  getPrintHtmlUrl: (receiptNo) => {
    return `${api.defaults.baseURL}/receipts/print-html?receiptNo=${encodeURIComponent(receiptNo)}`;
  },
};

export default receiptService;
